// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"318":"capture","427":"connect","443":"about","497":"config"}[chunkId] + "." + {"318":"2bcd9f5c","427":"84af0f49","443":"b4a7e670","497":"856c07ec"}[chunkId] + ".js";
};